import React from 'react';
import './BackupList.css';

const BackupList = ({ backups, onRestore, onDownload, onDelete, formatFileSize, formatDate }) => {
  return (
    <div className="backup-list">
      <table className="backup-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>District</th>
            <th>Filename</th>
            <th>Size</th>
            <th>Status</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {backups.map((backup) => (
            <tr key={backup.id}>
              <td>
                <span className={`backup-type-badge ${backup.backup_type}`}>
                  {backup.backup_type === 'full' ? 'Full' : 'District'}
                </span>
              </td>
              <td>
                {backup.district_subdomain || '-'}
              </td>
              <td className="filename-cell">
                <code>{backup.filename}</code>
              </td>
              <td>{formatFileSize(backup.size_bytes)}</td>
              <td>
                <span className={`status-badge ${backup.status}`}>
                  {backup.status}
                </span>
              </td>
              <td>{formatDate(backup.created_at)}</td>
              <td className="actions-cell">
                <button
                  onClick={() => onDownload(backup.filename)}
                  className="btn-download"
                  disabled={backup.status !== 'completed'}
                >
                  Download
                </button>
                <button
                  onClick={() => onRestore(backup)}
                  className="btn-restore"
                  disabled={backup.status !== 'completed'}
                >
                  Restore
                </button>
                <button
                  onClick={() => onDelete(backup)}
                  className="btn-delete"
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BackupList;
